import { AvisGoogleDetails } from '@components/avis-google-details/models';
import { Block } from '@shared/models';

export const avisGoogleDetailsMock: Block<AvisGoogleDetails> = {
  type: 'avis-google-details',
  data: {
    title: {
      text: `Si vous venez de la part de Marco, Zaza ou Flo, [[c'est qu'on a fait le job]]`,
      as: 'h2',
    },
    reviewStats: {
      totalReviews: 63443,
      averageRating: 4.8,
    },
  },
};
